/**
 * 认证相关的中文语言包
 */
export default {
  title: '智慧物流平台',
  subtitle: '让国际物流更简单',
  login: {
    welcome: '欢迎回来',
    description: '登录您的账户继续使用智慧物流服务',
    passwordLogin: '密码登录',
    codeLogin: '验证码登录',
    accountLabel: '邮箱或手机号',
    phoneOrEmail: '手机号或邮箱',
    accountPlaceholder: '请输入邮箱或手机号',
    phoneOrEmailPlaceholder: '请输入手机号或邮箱',
    accountRequired: '请输入账户信息',
    passwordLabel: '密码',
    passwordPlaceholder: '请输入密码',
    passwordRequired: '请输入密码',
    codeLabel: '验证码',
    codePlaceholder: '请输入验证码',
    codeRequired: '请输入验证码',
    sendCode: '发送验证码',
    rememberMe: '记住我',
    forgotPassword: '忘记密码？',
    changePassword: '修改密码',
    loginButton: '立即登录',
    loggingIn: '登录中...',
    // 消息
    checkInputMessage: '请检查输入内容',
    passwordRequiredMessage: '请输入密码',
    codeRequiredMessage: '请输入验证码',
    loginSuccessMessage: '登录成功！欢迎回来 🎉',
    loginFailedMessage: '登录失败，请重试'
  },

  register: {
    title: '创建账户',
    description: '开启您的智慧物流之旅',
    usernameLabel: '用户名',
    usernamePlaceholder: '请输入用户名',
    usernameRequired: '请输入用户名',
    phoneLabel: '手机号',
    phonePlaceholder: '请输入手机号',
    phoneRequired: '请输入手机号',
    phoneCodeLabel: '手机验证码',
    phoneCodePlaceholder: '请输入验证码',
    phoneCodeRequired: '请输入手机验证码',
    sendCode: '发送验证码',
    emailLabel: '邮箱（可选）',
    emailPlaceholder: '请输入邮箱（可选）',
    passwordLabel: '设置密码',
    passwordPlaceholder: '至少6位密码',
    confirmPasswordLabel: '确认密码',
    confirmPasswordPlaceholder: '再次输入密码',
    agreementPrefix: '我已阅读并同意',
    userAgreement: '用户协议',
    and: '和',
    privacyPolicy: '隐私政策',
    createButton: '创建账户',
    creating: '创建中...',
    // 消息
    fillAllFieldsMessage: '请填写所有必填字段',
    passwordMismatchMessage: '两次输入的密码不一致',
    registerSuccessMessage: '注册成功！欢迎加入我们 🌟',
    registerSuccessLoginMessage: '注册成功，请登录',
    registerFailedMessage: '注册失败，请重试'
  },

  switch: {
    noAccount: '还没有账户？',
    hasAccount: '已有账户？',
    register: '立即注册',
    login: '立即登录'
  },

  decoration: {
    globalNetwork: '全球物流网络',
    networkDescription: '连接全球港口，提供端到端的物流解决方案',
    smartManagement: '智能管理',
    smartDescription: 'AI驱动的智能物流管理系统，提升效率降低成本'
  },

  agreement: {
    title: '用户协议',
    subtitle: '智慧物流平台服务条款',
    understood: '我已阅读并理解',
    section1: {
      title: '1. 服务条款的接受',
      content:
        '欢迎使用智慧物流平台！本协议是您与本平台之间关于使用物流服务的法律协议。通过注册、访问或使用本服务，您表示同意接受本协议的所有条款和条件。'
    },
    section2: {
      title: '2. 物流服务内容',
      content:
        '本平台提供国际物流、货运代理、仓储管理、供应链优化等服务，具体功能以平台实际提供为准。我们致力于为客户提供高效、安全的物流解决方案。'
    },
    section3: {
      title: '3. 用户义务与责任',
      content:
        '您承诺提供真实、准确的货物信息和联系方式，并及时更新。您有责任确保货物的合法性，遵守相关进出口法规，配合海关检查等相关程序。'
    },
    section4: {
      title: '4. 服务费用与结算',
      content:
        '物流服务费用将根据货物重量、体积、运输距离、服务类型等因素确定。费用标准透明公开，支持多种结算方式，确保交易安全。'
    },
    section5: {
      title: '5. 免责条款',
      content:
        '在法律允许范围内，对于不可抗力、政策变化、海关扣留等因素导致的延误或损失，平台不承担责任。建议客户购买相应的货物保险。'
    }
  },

  privacy: {
    title: '隐私政策',
    subtitle: '我们如何保护您的个人信息',
    understood: '我已阅读并理解',
    section1: {
      title: '1. 信息收集与使用',
      content:
        '我们收集您的联系信息、货物详情、交易记录等，用于提供物流服务、优化用户体验、保障交易安全。所有信息均严格保密，不会用于其他商业用途。'
    },
    section2: {
      title: '2. 数据安全保护',
      content:
        '采用银行级别的数据加密技术，建立多重安全防护体系，定期进行安全审计，确保您的个人信息和交易数据安全。'
    },
    section3: {
      title: '3. 第三方合作',
      content:
        '为完成物流服务，我们可能与承运商、海关、港口等第三方机构共享必要信息。所有合作方均签署保密协议，确保信息安全。'
    },
    section4: {
      title: '4. 数据存储与跨境传输',
      content:
        '您的数据主要存储在中国境内的安全服务器中。对于国际物流业务，可能涉及跨境数据传输，我们将遵循相关法律法规要求。'
    },
    section5: {
      title: '5. 您的权利',
      content:
        '您有权访问、更正、删除个人信息，撤回同意，以及要求数据可携带。如需行使这些权利或有任何隐私问题，请联系我们的客服团队。'
    }
  },

  // 员工认证专用
  staff: {
    title: '控制塔系统',
    subtitle: '员工专用管理平台',
    backToPortal: '返回首页',

    login: {
      title: '员工登录',
      description: '使用您的员工账户登录控制塔系统',
      quickLogin: '快速登录',
      or: '或使用账号登录',
      passwordLogin: '密码登录',
      codeLogin: '验证码登录',
      accountLabel: '邮箱或手机号',
      accountPlaceholder: '请输入邮箱或手机号',
      passwordLabel: '密码',
      passwordPlaceholder: '请输入密码',
      codeLabel: '验证码',
      codePlaceholder: '请输入验证码',
      sendCode: '发送验证码',
      rememberMe: '记住我',
      forgotPassword: '忘记密码？',
      loginButton: '立即登录',
      loggingIn: '登录中...'
    },

    register: {
      title: '员工注册',
      description: '创建员工账户加入控制塔系统',
      nameLabel: '员工姓名',
      namePlaceholder: '请输入员工姓名',
      phoneLabel: '手机号',
      phonePlaceholder: '请输入手机号',
      phoneCodeLabel: '手机验证码',
      phoneCodePlaceholder: '请输入验证码',
      sendCode: '发送验证码',
      emailLabel: '企业邮箱',
      emailPlaceholder: '请输入企业邮箱',
      passwordLabel: '设置密码',
      passwordPlaceholder: '至少6位密码',
      confirmPasswordLabel: '确认密码',
      confirmPasswordPlaceholder: '再次输入密码',
      createButton: '创建账户',
      creating: '创建中...'
    },

    switch: {
      noAccount: '还没有员工账户？',
      hasAccount: '已有员工账户？',
      register: '立即注册',
      login: '立即登录'
    },

    decoration: {
      title: '控制塔系统',
      description: '集中管理、实时监控、智能决策的企业级平台',
      staffTitle: '员工专区',
      staffDescription: '专为企业员工打造的专业物流管理平台'
    },

    messages: {
      loginSuccess: '员工登录成功！欢迎使用控制塔系统 🎉',
      loginFailed: '登录失败，请检查账号密码',
      registerSuccess: '注册成功！请登录您的账户',
      registerNotAvailable: '注册功能暂未开放，请联系管理员',
      codeSent: '验证码已发送 📱',
      enterAccountFirst: '请先输入邮箱或手机号',
      ssoRedirect: '正在跳转到 {provider} 登录',
      imageLoadError: '图片加载失败'
    },

    validation: {
      accountRequired: '请输入邮箱或手机号',
      passwordRequired: '请输入密码',
      codeRequired: '请输入验证码',
      nameRequired: '请输入员工姓名',
      phoneRequired: '请输入手机号',
      phoneInvalid: '请输入有效的手机号',
      emailRequired: '请输入企业邮箱',
      emailInvalid: '请输入有效的邮箱格式',
      passwordMinLength: '密码至少6位',
      confirmPasswordRequired: '请确认密码',
      passwordMismatch: '两次输入的密码不一致'
    },

    // 密码重置模态框
    resetPassword: {
      title: '🔑 修改密码',
      description: '为了您的账户安全，请输入您的账户信息和新密码。验证码将发送到您的手机或邮箱。',
      accountLabel: '账户信息',
      accountPlaceholder: '请输入手机号或邮箱地址',
      accountRequired: '请输入手机号或邮箱',
      codeLabel: '验证码',
      codePlaceholder: '请输入6位验证码',
      codeRequired: '请输入验证码',
      sendCode: '发送验证码',
      resendAfter: 's后重发',
      newPasswordLabel: '新密码',
      newPasswordPlaceholder: '请输入新密码（至少6位）',
      newPasswordRequired: '请输入新密码',
      passwordMinLength: '密码至少6位',
      confirmPasswordLabel: '确认新密码',
      confirmPasswordPlaceholder: '请再次输入新密码',
      confirmPasswordRequired: '请确认新密码',
      submitButton: '确认修改',
      cancelButton: '取消',
      successMessage: '密码重置成功！',
      failedMessage: '密码重置失败，请重试',
      codeSentMessage: '验证码已发送 📱',
      codeFailedMessage: '验证码发送失败，请重试',
      enterAccountFirst: '请先输入账号',
      enterPhoneFirst: '请先输入手机号',
      enterValidPhone: '请输入有效的手机号'
    }
  },

  // 修改密码弹窗
  forgotPassword: {
    title: '修改密码',
    description: '为了您的账户安全，请输入您的账户信息和新密码。验证码将发送到您的手机或邮箱。',
    accountLabel: '账户信息',
    accountPlaceholder: '请输入手机号或邮箱地址',
    accountRequired: '请输入手机号或邮箱',
    codeLabel: '短信验证码',
    codePlaceholder: '请输入6位验证码',
    codeRequired: '请输入验证码',
    sendCode: '发送验证码',
    resendCode: '重发',
    newPasswordLabel: '新密码',
    newPasswordPlaceholder: '请输入新密码（至少6位）',
    newPasswordRequired: '请输入新密码',
    confirmPasswordLabel: '确认新密码',
    confirmPasswordPlaceholder: '请再次输入新密码',
    confirmPasswordRequired: '请确认新密码',
    passwordMismatch: '两次输入的密码不一致',
    submitButton: '确认修改',
    cancelButton: '取消',
    successMessage: '密码修改成功！请重新登录 🎉',
    failedMessage: '密码修改失败，请重试',
    codeSentMessage: '验证码已发送 📱',
    codeFailedMessage: '验证码发送失败，请重试'
  },

  // Store相关的消息
  store: {
    loginStart: '开始登录认证',
    passwordLoginStart: '密码登录',
    codeLoginStart: '验证码登录',
    loginSuccess: '登录成功',
    loginFailed: '登录失败',
    registerCodeSent: '发送注册验证码',
    registerCodeFailed: '发送注册验证码失败',
    registerStart: '用户注册',
    registerSuccess: '注册成功',
    registerFailed: '注册失败',
    loginCodeSent: '发送登录验证码',
    loginCodeFailed: '发送登录验证码失败',
    resetCodeSent: '发送密码重置验证码',
    resetCodeFailed: '发送密码重置验证码失败',
    resetPasswordStart: '重置密码',
    resetPasswordSuccess: '密码重置成功',
    resetPasswordFailed: '密码重置失败',
    logoutStart: '开始登出操作',
    logoutSuccess: '登出成功',
    logoutFailed: '登出失败',
    tokenStored: 'Token 已同时存储到 cookies 和 localStorage',
    authStateReset: '认证状态已重置',
    tokenCleared: 'Token 已从 cookies 和 localStorage 中清除',
    tabsCacheCleared: 'Tabs缓存已清除',
    userInfoUpdated: '用户信息已更新',
    authInitStart: '初始化认证状态...',
    authRestored: '从本地存储恢复登录状态',
    authRestoreSuccess: '认证状态恢复成功',
    authRestoreFailed: '认证状态检查失败',
    noValidAuth: '无有效的登录状态'
  },

  // 密码重置相关
  resetPassword: {
    title: '重置密码',
    accountLabel: '账号',
    accountPlaceholder: '请输入手机号/邮箱/用户名',
    accountRequired: '请输入账号',
    codeLabel: '验证码',
    codePlaceholder: '请输入验证码',
    codeRequired: '请输入验证码',
    sendCode: '发送验证码',
    newPasswordLabel: '新密码',
    newPasswordPlaceholder: '请输入新密码',
    newPasswordRequired: '请输入新密码',
    confirmPasswordLabel: '确认密码',
    confirmPasswordPlaceholder: '请再次输入新密码',
    confirmPasswordRequired: '请确认新密码',
    submitButton: '重置密码',
    cancelButton: '取消',
    passwordMismatch: '两次输入的密码不一致'
  },
  tenantSelect: {
    title: '选择租户',
    desc: '当前账号归属于多个租户，请选择您要登录的租户',
    label: '租户列表',
    cancel: '取消',
    confirm: '确认',
    error: '请选择租户',
    selectPlaceholder: '请选择租户'
  },

  // 租户登录相关
  tenantLogin: {
    title: '智慧物流平台',
    subtitle: '让国际物流更简单',
    backToHome: '返回首页',

    // 登录页面
    login: {
      welcome: '欢迎回来',
      description: '登录您的账户继续使用智慧物流服务',
      globalNetwork: '全球物流网络',
      networkDescription: '连接全球港口，提供端到端的物流解决方案'
    },

    // 注册页面
    register: {
      title: '创建账户',
      description: '开启您的智慧物流之旅',
      joinUs: '加入我们',
      joinDescription: '数万家企业的选择，开启智慧物流新体验'
    },

    // 切换链接
    switch: {
      noAccount: '还没有账户？',
      hasAccount: '已有账户？',
      register: '立即注册',
      login: '立即登录'
    },

    // 租户选择弹窗
    tenantModal: {
      title: '选择租户',
      description: '当前账号归属于多个租户，请选择您要登录的租户',
      label: '租户列表',
      personalAccount: '个人账号',
      cancel: '取消',
      confirm: '确认'
    },

    // 账号已注册提醒弹窗
    accountExists: {
      title: '账号提醒',
      description: '系统检测到您可能已有账号',
      mainTitle: '当前账号已注册',
      content: '检测到您的账号信息已存在于系统中，无需重复注册。请直接使用现有账号登录，享受我们的智慧物流服务。',
      tipTitle: '温馨提示：',
      tipContent: '如果您忘记了登录密码，可以使用"忘记密码"功能重置密码。',
      cancel: '取消',
      goToLogin: '去登录'
    },

    // 忘记密码弹窗
    forgotPassword: {
      title: '修改密码',
      description: '为了您的账户安全，请输入您的账户信息和新密码',
      accountLabel: '账户信息',
      accountPlaceholder: '请输入手机号或邮箱地址',
      codeLabel: '短信验证码',
      codePlaceholder: '请输入6位验证码',
      sendCode: '发送验证码',
      resendAfter: 's后重发',
      newPasswordLabel: '新密码',
      newPasswordPlaceholder: '请输入新密码（至少6位）',
      confirmPasswordLabel: '确认新密码',
      confirmPasswordPlaceholder: '请再次输入新密码',
      cancel: '取消',
      confirm: '确认修改',
      resetting: '重置中...',
      successMessage: '密码重置成功！',
      failedMessage: '密码重置失败，请重试'
    },

    // 消息提示
    messages: {
      loginSuccess: '登录成功！欢迎回来 🎉',
      loginFailed: '登录失败，请重试',
      registerSuccess: '注册成功！欢迎加入我们 🌟',
      registerFailed: '注册失败，请重试',
      codeSent: '验证码已发送 📱',
      codeFailed: '验证码发送失败，请重试',
      enterAccountFirst: '请先输入手机号或邮箱',
      enterPhoneFirst: '请先输入手机号',
      enterValidPhone: '请输入有效的手机号',
      enterAccount: '请先输入账号',
      passwordMismatch: '两次输入的密码不一致',
      personalLoginSuccess: '登录成功！欢迎使用个人账号 👤',
      enterpriseLoginSuccess: '登录成功！欢迎进入企业控制塔 🏢'
    }
  },

  // SSO授权相关
  sso: {
    backToLogin: '返回登录',
    back: '返回',
    authLogin: '授权登录',
    authDescription: '请使用您的 {provider} 账户进行授权',
    usernameLabel: '用户名',
    usernamePlaceholder: '请输入用户名',
    usernameRequired: '请输入用户名',
    passwordLabel: '密码',
    passwordPlaceholder: '请输入密码',
    passwordRequired: '请输入密码',
    authButton: '授权登录',
    authorizing: '授权中...',
    authAgreement: '登录即表示您同意授权控制塔系统访问您的 {provider} 账户信息',
    selectTenant: '选择租户',
    selectTenantDesc: '请输入租户名称、英文名或ID进行检索',
    tenantLabel: '租户列表',
    tenantPlaceholder: '请输入租户名称、英文名或ID',
    noMatchResult: '无匹配结果',
    cancel: '取消',
    confirmBind: '确认绑定',
    selectTenantError: '请选择租户',
    verifyUser: '验证用户',
    verifyUserDesc: '登录名已经存在系统中，请选择用户，输入密码进行验证',
    selectUserPlaceholder: '请选择账号',
    loginSuccess: '登录成功',
    loginFailed: '登录失败，请重试',
    verifyLogin: '验证登陆',
    passwordError: '密码错误'
  },

  // 新增：登录来源类型枚举
  enum: {
    loginOriginType: {
      WTF: 'walltech family',
      CARGO: 'CargoWare',
      ETOWER: 'eTower'
    }
  }
}
